import _ from "lodash";
import React, { useCallback, useState } from "react";

import AssignmentActionsDropdown from "./AssignmentActionsDropdown";
import CompactLEPreview from "AppComponents/CompactLEPreview/";

import UIModal from "UIComponents/UIModal";

const AssignmentActionsDropdownWrapper = props => {
  const [previewPropsObj, setPreviewPropsObj] = useState({});

  const handlePreviewOpen = useCallback(params => {
    setPreviewPropsObj(params);
  }, []);

  const handlePreviewClose = useCallback(() => {
    const onCloseClickAction = _.get(
      previewPropsObj,
      "onCloseClickAction",
      () => {}
    );
    onCloseClickAction();
    setPreviewPropsObj({});
  }, [previewPropsObj]);

  return (
    <>
      {/* Dropdown */}
      <AssignmentActionsDropdown
        {...props}
        onPreviewClick={handlePreviewOpen} // function to trigger compact le preview
      />

      {!_.isEmpty(previewPropsObj) && (
        <UIModal isOpen={true} isFullScreen={true}>
          <CompactLEPreview
            onCloseClick={handlePreviewClose}
            {...previewPropsObj}
            AssignmentActionsDropdown={AssignmentActionsDropdown}
          />
        </UIModal>
      )}
    </>
  );
};

export default AssignmentActionsDropdownWrapper;
